<div class="p-4 flex flex-col gap-4">
  <h6 id="h-idle-warning">Still there?</h6>
    
  <p class="body-default-regular">{{idleMessage}}</p>

    <div class="flex flex-row justify-end gap-4">
      <button
        class="btn btn-neutral border"
        (click)="onBtnLogoutClick()"
        id="btn-logout"
      >
        Log Out
      </button>
      <button
        class="btn btn-primary"
        id="btn-continue-working"
        (click)="onBtnContinueWorkingClick()"
      >
        Continue Working
      </button>
    </div>
</div>
